export default "__VITE_ASSET__61277572__"